import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import {
  type IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath.ts';
import { isPlainAdvancedSelectColumn } from '../advanced-select-common/IAdvancedSelectColumns.ts';
import { getUniqueOptionValue } from '../advanced-select-common/utils/geUniqueOptionValue.ts';
import { renderAdvancedSelectedOptionLabel } from '../advanced-select-common/utils/renderAdvancedSelectedOptionLabel.ts';
import { type IAdvancedSingleSelectWidget } from './IAdvancedSingleSelectWidget.ts';

/**
 * Come reference principale del widget AdvancedSelect viene utilizzato il valore
 * corrispondente alla colonna "ID" (selezionata dall'utente) dell'opzione scelta
 */
export function getAdvancedSingleSelectMainReference(
  path: IReferencePath,
  widget: IAdvancedSingleSelectWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path: [
      ...path,
      {
        direction: ReferencePathDirection.Child,
        code: widget.code,
      },
    ],
    id: widget.id,
    code: widget.uniqueValueColumnId,
    label: widget.code,
    field: {
      type: Datatype.String,
      options: widget.options.map(option => ({
        value: getUniqueOptionValue(widget, option),
        label: renderAdvancedSelectedOptionLabel(
          option.values,
          widget.labelFieldColumns,
          widget.columns,
        ),
      })),
    },
  };
}

/**
 * Ottiene i riferimenti alle altre colonne del widget AdvancedSelect
 */
export function getAdvancedSingleSelectColumnsReferences(
  path: IReferencePath,
  widget: IAdvancedSingleSelectWidget,
): IReference[] {
  if (!widget.columns || widget.columns.length === 0) {
    return [];
  }

  return widget.columns.filter(isPlainAdvancedSelectColumn).map(column => ({
    type: ReferenceType.Widget,
    widgetType: null,
    id: `${widget.id}-${column.id}`,
    code: column.id,
    label: `${widget.code}: ${column.label}`,
    path: [
      ...path,
      {
        direction: ReferencePathDirection.Child,
        code: widget.code,
      },
    ],
    field: { type: column.type },
  }));
}
